export default __webpack_public_path__ + "static/media/icon-crown.d5e05350.svg";